import { render, staticRenderFns } from "./Chronology.vue?vue&type=template&id=2574d21f&scoped=true&"
import script from "./Chronology.vue?vue&type=script&lang=js&"
export * from "./Chronology.vue?vue&type=script&lang=js&"
import style0 from "./Chronology.vue?vue&type=style&index=0&id=2574d21f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574d21f",
  null
  
)

export default component.exports